import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getMyResources } from 'services/app';

import { IResource } from '../ResourceCard';

export interface IMyResourcesResponse {
  drafts: IResource[];
  published: IResource[];
}

export default function useMyResources(
  options?: Omit<
    UseQueryOptions<IMyResourcesResponse, Error, IMyResourcesResponse, QueryKey>,
    'queryKey'
  >
) {
  return useQuery<IMyResourcesResponse, Error>(
    `my-resources`,
    () =>
      getMyResources().then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
      retry: false,
    }
  );
}
